module.exports = __webpack_public_path__ + "img/card-amex.1b139735.svg";